// api.js
import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

const shopapi = axios.create({
    baseURL: process.env.REACT_APP_API_SHOP_URL,
    withCredentials: true,
});

export default api; // default export
export { shopapi }; // named export
